export enum VizSubType {
  Table = 'table',
  Pie = 'pie',
  Scatter = 'scatter',
  ScatterGl = 'scattergl',
  Heatmap = 'heatmap',
  Bar = 'bar',
  Treemap = 'treemap'
}
